import { Flex, Link, Text } from "@chakra-ui/react";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import AvelaLogo from "src/images/logo-gray.svg?react";

type Props = {
  config: OrgConfig.AccountLookupConfig;
};

export const Footer: React.FC<Props> = (props) => {
  const { config } = props;

  return (
    <Flex direction="column" gap={3} alignItems="center">
      <AvelaLogo aria-label="Avela" height="1.5rem" width="6rem" />
      <Text fontSize="0.75rem" color="gray.600">
        Stuck?{" "}
        <Link href={config.supportUrl} isExternal textDecoration="underline">
          Get help now
        </Link>
      </Text>
    </Flex>
  );
};
